import React from 'react'; 
import logo from '../images/logo.png';

class Login extends React.Component { 
    constructor(props){
        super(props); 

    }

    render() {
        return (
            <div className="container d-flex align-items-center col justify-content-center" style={{height: '80vh'}}>
                <div className="card" style={{width: '400px'}}>
                    <img src={logo} style={{ width: '216px', height: 'auto'}} className="mx-auto d-block" alt="Adapticts.com" />
                    <div className="card-body">
                        <h1 className="h3 mb-3 font-weight-normal">Please sign in</h1>
                        <div className="form-group">
                            <label>Username</label>
                            <input type="text" className="form-control" onChange={ (event) => this.props.handleUsernameChange(event) }/>
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input type="password" className="form-control" onChange={ (event) => this.props.handlePasswordChange(event) } />
                        </div>
                        <p className="text-danger">{ this.props.loginMessage }</p>
                        <button className="btn btn-lg btn-outline-secondary btn-block" onClick={ () => this.props.login() }>Sign In</button>
                    </div>
                </div>
            </div>
        )
    }
}



export default Login;